namespace GeniuzPOS.PosShift {
    export interface ReportSaleTaxTreeData extends Serenity.ListRequest {
        Details?: ReportSaleTaxTreeTaxRow[];
        Year?: string;
        Month?: string;
        user?: string;
        username?: string;
        BizName?: string;
        ShopName?: string;
        ShopAddress?: string;
        ShopTaxId?: string;
        BranchName?: string;
    }
}
